import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSessions } from "../../../../api/SessionsService";
import { courseList } from "../../../../api/Courses";
import { LoadingDiv, SweetAlertShow, ToastMain } from "../../../master/Master";
import { getBatchList } from "../../../../api/BatchService";
import { getTestSeriesList } from "../../../../api/TestService";
import Header from "../../../master/SideBar";
import Nav from "../../../master/NavBar";
import TestLayout from "../TestLayout";
import { testUpdate } from "../../../../api/TestServiceV2";

const UpdateTest = () => {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [batch, setBatch] = useState([]);
  const [error, setError] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = location.state || {};

  const [selectedSubjectIds, setSelectedSubjectIds] = useState([]);
  const [marksList, setMarksList] = useState({});
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [typeTest, setTypeTest] = useState("");
  const [selectedSeriesId, setSelectedSeriesId] = useState("");
  const [totalMarks, setTotalMarks] = useState(0);
  const [Data, setData] = useState([]);
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [selectedSession, setSelectedSession] = useState("");

  const [scheduleData, setScheduleData] = useState([]);
  const [enableTimeTable, setEnableTimeTable] = useState(false);

  const originalScheduleRef = useRef([]);

  const [examMode, setExamMode] = useState("normal");
  const [combinedMarks, setCombinedMarks] = useState("");
  const [resultType, setResultType] = useState("numerical");

  const [combinedSchedule, setCombinedSchedule] = useState({
    date: "",
    start_time: "",
    end_time: "",
  });

  // ----------------- Session -----------------
  useEffect(() => {
    const getSession = async () => {
      try {
        const res = await getSessions();
        if (res?.data?.status) {
          const active = res.data.data.find((s) => s.status === "1");
          setSelectedSession(active?.id);
        }
      } catch (e) {}
    };
    getSession();
  }, []);

  // ----------------- Prefill exam mode / combined marks -----------------
  useEffect(() => {
    if (!item) return;

    if (item?.exam_mode) {
      setExamMode(item.exam_mode);
    }

    if (item?.combined_marks !== null && item?.combined_marks !== undefined) {
      setCombinedMarks(item.combined_marks);
    }

    setResultType(item?.result_type || "numerical");
  }, [item]);

  // ----------------- Prefill subjects + marks -----------------
  useEffect(() => {
    if (!item?.subjects) return;

    try {
      const parsedSubjects = JSON.parse(item.subjects).map((id) => Number(id));
      setSelectedSubjectIds(parsedSubjects);

      if (item?.subjects_marks) {
        const parsedMarks = JSON.parse(item.subjects_marks).map(Number);

        const marksObj = {};
        parsedSubjects.forEach((id, index) => {
          marksObj[id] = parsedMarks[index] || 0;
        });

        setMarksList(marksObj);
      }
    } catch (e) {}
  }, [item]);

  useEffect(() => {
    if (item?.subject_schedule) {
      try {
        const parsed = JSON.parse(item.subject_schedule);

        if (Array.isArray(parsed) && parsed.length > 0) {
          originalScheduleRef.current = parsed;

          if (item?.exam_mode === "combined") {
            const row = parsed[0];

            setCombinedSchedule({
              date: row?.date || "",
              start_time: row?.start_time || "",
              end_time: row?.end_time || "",
            });
          } else {
            setScheduleData(parsed);
          }

          setEnableTimeTable(true);
        }
      } catch (e) {}
    }
  }, [item]);

  useEffect(() => {
    if (!item) return;

    if (
      item.parent_id !== null &&
      item.parent_id !== undefined &&
      item.parent_id !== ""
    ) {
      setTypeTest("series");
      setSelectedSeriesId(item.parent_id);
    } else {
      setTypeTest("notseries");
      setSelectedSeriesId("");
    }
  }, [item]);

  useEffect(() => {
    if (item?.course_id) {
      setSelectedCourseId(item.course_id);
      batchFetch(item.course_id);

      const ids = Array.isArray(item.batch_id)
        ? item.batch_id.map(Number)
        : JSON.parse(item.batch_id || "[]").map(Number);

      setSelectedBatchIds(ids);
    }
    // eslint-disable-next-line
  }, [item]);

  useEffect(() => {
    const selectedCourse = courses.find(
      (c) => c.id === Number(selectedCourseId),
    );
    setSelectedSubjects(selectedCourse?.subjects_list || []);
  }, [selectedCourseId, courses]);

  useEffect(() => {
    if (examMode === "combined") return;

    setScheduleData((prevSchedule) => {
      const selectedSubjectObjs = selectedSubjects.filter((sub) =>
        selectedSubjectIds.includes(sub.id),
      );

      return selectedSubjectObjs.map((sub) => {
        const existingInState = prevSchedule.find(
          (row) => Number(row.subject_id) === Number(sub.id),
        );

        if (
          existingInState &&
          (existingInState.date ||
            existingInState.start_time ||
            existingInState.end_time)
        ) {
          return existingInState;
        }

        const existingOriginal = originalScheduleRef.current.find(
          (row) => Number(row.subject_id) === Number(sub.id),
        );

        if (existingOriginal) {
          return {
            subject_id: sub.id,
            subject_name: sub.name,
            date: existingOriginal.date || "",
            start_time: existingOriginal.start_time || "",
            end_time: existingOriginal.end_time || "",
          };
        }

        // 3) Genuinely new subject with no prior schedule — empty row.
        return {
          subject_id: sub.id,
          subject_name: sub.name,
          date: "",
          start_time: "",
          end_time: "",
        };
      });
    });
  }, [selectedSubjectIds, selectedSubjects, examMode]);

  // ----------------- Total Marks -----------------
  useEffect(() => {
    if (examMode === "combined") {
      setTotalMarks(Number(combinedMarks) || 0);
    } else {
      const total = Object.values(marksList).reduce(
        (sum, m) => sum + (Number(m) || 0),
        0,
      );
      setTotalMarks(total);
    }
  }, [marksList, combinedMarks, examMode]);

  // ----------------- Subject handlers -----------------
  const handleCheckboxChange = (subject) => {
    const id = Number(subject.id);

    setSelectedSubjectIds((prev) => {
      if (prev.includes(id)) {
        const updatedIds = prev.filter((i) => i !== id);

        setMarksList((marks) => {
          const newMarks = { ...marks };
          delete newMarks[id];
          return newMarks;
        });

        return updatedIds;
      } else {
        setMarksList((marks) => ({ ...marks, [id]: 0 }));
        return [...prev, id];
      }
    });
  };

  const handleMarksChange = (subjectId, value) => {
    setMarksList((prev) => ({ ...prev, [subjectId]: Number(value) }));
  };

  const handleScheduleChange = (index, field, value) => {
    const updated = [...scheduleData];
    updated[index][field] = value;
    setScheduleData(updated);
  };

  // 🔥 Combined-mode single-row schedule handler
  const handleCombinedScheduleChange = (field, value) => {
    setCombinedSchedule((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // ----------------- Batch handlers -----------------
  const handleBatchToggle = (id) => {
    setSelectedBatchIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id],
    );
  };

  const handleBatchSelectAll = () => {
    setSelectedBatchIds(batch.map((b) => Number(b.id)));
  };

  const handleBatchClearAll = () => {
    setSelectedBatchIds([]);
  };

  // ----------------- API calls -----------------
  const courseFetch = async () => {
    setLoading(true);
    try {
      const res = await courseList();
      if (res?.data?.status) setCourses(res.data.data);
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const batchFetch = async (id) => {
    setLoading(true);
    try {
      const res = await getBatchList(
        `&session_id=${selectedSession}&course_id=${id}`,
      );
      if (res?.data?.batches) setBatch(res.data.batches);
      else if (res?.data?.data) setBatch(res.data.data);
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchSeriesList = async () => {
    setLoading(true);
    try {
      const res = await getTestSeriesList();
      if (res?.data?.status) setData(res.data.data);
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    courseFetch();
    fetchSeriesList();
    // eslint-disable-next-line
  }, []);

  const UpTest = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(e.target);

      // remove raw batch_id[] captured directly from checkboxes; we control via state instead
      formData.delete("batch_id[]");

      selectedBatchIds.forEach((id) => {
        formData.append("batch_id[]", id);
      });

      selectedSubjectIds.forEach((id) => {
        formData.append("subjects[]", id);
      });

      selectedSubjectIds.forEach((id) => {
        formData.append("subjects_marks[]", marksList[id] || 0);
      });

      // 🔥 test_type must reflect whether a series is actually selected —
      // not just what the dropdown says. If a parent series is chosen,
      // this test belongs to that series; otherwise it stands alone.
      const finalTestType = selectedSeriesId ? "series" : "notseries";

      formData.delete("test_type");
      formData.append("test_type", finalTestType);

      formData.delete("parent_id");
      if (selectedSeriesId) {
        formData.append("parent_id", selectedSeriesId);
      }

      formData.delete("exam_mode");
      formData.append("exam_mode", examMode);
      formData.delete("combined_marks");
      formData.append("combined_marks", combinedMarks);
      formData.delete("result_type");
      formData.append("result_type", resultType);

      if (enableTimeTable) {
        if (examMode === "combined") {
          // 🔥 Combined mode → single schedule entry (no per-subject split)
          const singleSchedule = [
            {
              subject_id: null,
              subject_name: "Combined Exam",
              date: combinedSchedule.date,
              start_time: combinedSchedule.start_time,
              end_time: combinedSchedule.end_time,
            },
          ];

          formData.append("subject_schedule", JSON.stringify(singleSchedule));
        } else {
          formData.append("subject_schedule", JSON.stringify(scheduleData));
        }
      } else {
        formData.append("subject_schedule", JSON.stringify([]));
      }

      const res = await testUpdate(formData);

      if (res?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Updated Successfully!",
        }).then(() => {
          navigate(-1);
        });
      } else {
        if (res?.data?.errors) setError(res.data.errors);

        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) setError(error.response.data.errors);

      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const hasErrors = error && Object.keys(error).length > 0;

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row">
                  <TestLayout />

                  <div className="col-12">
                    {/* =====================================================
                        PAGE HEADER
                    ====================================================== */}
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body p-4">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: 48,
                                height: 48,
                                minWidth: 48,
                              }}
                            >
                              <i className="ri-edit-line fs-3 text-primary"></i>
                            </div>

                            <div>
                              <h4 className="mb-1 fw-bold">Update Test</h4>

                              <p className="text-muted mb-0">
                                Edit test details, subjects, batches, marks and
                                schedule.
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate(-1)}
                          >
                            <i className="ri-arrow-left-line me-1"></i>
                            Back
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                        FORM
                    ====================================================== */}
                    <div className="card border-0 shadow-sm">
                      <div className="card-body p-4">
                        {/* =================================================
                            VALIDATION ERRORS
                        ================================================== */}
                        {hasErrors && (
                          <div
                            className="alert alert-danger d-flex align-items-start mb-4"
                            role="alert"
                          >
                            <i className="ri-error-warning-line fs-5 me-2"></i>

                            <div>
                              <strong className="d-block mb-1">
                                Please check the following:
                              </strong>

                              <ul className="mb-0 ps-3">
                                {Object.entries(error).map(([key, msg]) => (
                                  <li key={key}>
                                    {Array.isArray(msg) ? msg[0] : msg}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}

                        <form onSubmit={UpTest}>
                          <input
                            type="hidden"
                            name="id"
                            value={item?.id || ""}
                          />

                          {/* =================================================
                              TEST DETAILS
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-file-text-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Test Details
                                </h5>

                                <small className="text-muted">
                                  Basic information about this test.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              {/* Test Title */}
                              <div className="col-12">
                                <label className="form-label">
                                  Test Title
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <input
                                  type="text"
                                  name="title"
                                  defaultValue={item?.title || ""}
                                  className={`form-control input-capitalize ${
                                    error?.title ? "is-invalid" : ""
                                  }`}
                                  placeholder="Enter test title"
                                />

                                {error?.title && (
                                  <div className="text-danger small mt-1">
                                    {Array.isArray(error.title)
                                      ? error.title[0]
                                      : error.title}
                                  </div>
                                )}
                              </div>

                              {/* Test Type */}
                              <div
                                className={
                                  typeTest === "series"
                                    ? "col-md-4"
                                    : "col-md-6"
                                }
                              >
                                <label className="form-label">
                                  Test Type
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <select
                                  name="test_type"
                                  className={`form-select ${
                                    error?.test_type ? "is-invalid" : ""
                                  }`}
                                  value={typeTest}
                                  onChange={(e) => setTypeTest(e.target.value)}
                                >
                                  <option value="">Select Test Type</option>

                                  <option value="series">Test Series</option>

                                  <option value="notseries">
                                    Without Series
                                  </option>
                                </select>

                                {error?.test_type && (
                                  <div className="text-danger small mt-1">
                                    {Array.isArray(error.test_type)
                                      ? error.test_type[0]
                                      : error.test_type}
                                  </div>
                                )}
                              </div>

                              {/* Series */}
                              {typeTest === "series" && (
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Test Series
                                  </label>

                                  <select
                                    name="parent_id"
                                    className="form-select"
                                    value={selectedSeriesId}
                                    onChange={(e) =>
                                      setSelectedSeriesId(e.target.value)
                                    }
                                  >
                                    <option value="">Select Test Series</option>

                                    {Data?.data?.map((series) => (
                                      <option key={series.id} value={series.id}>
                                        {series.title}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              )}

                              {/* Exam Date */}
                              <div
                                className={
                                  typeTest === "series"
                                    ? "col-md-4"
                                    : "col-md-6"
                                }
                              >
                                <label className="form-label">Exam Date</label>

                                <input
                                  type="date"
                                  name="date"
                                  defaultValue={item?.date || ""}
                                  className="form-control"
                                />
                              </div>
                            </div>
                          </div>

                          <hr className="my-4" />

                          {/* =================================================
                              COURSE & BATCHES
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-group-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Course & Batches
                                </h5>

                                <small className="text-muted">
                                  Select the course and batches for this test.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              {/* Course */}
                              <div className="col-md-6">
                                <label className="form-label">
                                  Course
                                  <span className="text-danger ms-1">*</span>
                                </label>

                                <select
                                  name="course_id"
                                  className={`form-select ${
                                    error?.course_id ? "is-invalid" : ""
                                  }`}
                                  value={selectedCourseId}
                                  onChange={(e) => {
                                    setSelectedCourseId(e.target.value);
                                    batchFetch(e.target.value);
                                  }}
                                >
                                  <option value="">Select Course</option>

                                  {courses?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                      {course.title}
                                    </option>
                                  ))}
                                </select>

                                {error?.course_id && (
                                  <div className="text-danger small mt-1">
                                    {Array.isArray(error.course_id)
                                      ? error.course_id[0]
                                      : error.course_id}
                                  </div>
                                )}
                              </div>

                              {/* Batches */}
                              <div className="col-md-6">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="form-label mb-0">
                                    Batches
                                  </label>

                                  {batch?.length > 0 && (
                                    <div className="d-flex gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-link p-0"
                                        onClick={handleBatchSelectAll}
                                      >
                                        Select All
                                      </button>

                                      <button
                                        type="button"
                                        className="btn btn-sm btn-link text-muted p-0"
                                        onClick={handleBatchClearAll}
                                      >
                                        Clear
                                      </button>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="border rounded-2 p-3"
                                  style={{
                                    maxHeight: "180px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {batch?.length === 0 ? (
                                    <div className="text-center py-3 text-muted">
                                      <i className="ri-group-line fs-4 d-block mb-1"></i>

                                      <small>
                                        {selectedCourseId
                                          ? "No batches found."
                                          : "Select a course first."}
                                      </small>
                                    </div>
                                  ) : (
                                    batch.map((batchItem) => {
                                      const batchId = Number(batchItem.id);

                                      const isSelected =
                                        selectedBatchIds.includes(batchId);

                                      const courseTitle =
                                        batchItem?.course?.title || "";

                                      const shortCourseTitle =
                                        courseTitle.length > 20
                                          ? courseTitle.substring(0, 20) + "..."
                                          : courseTitle;

                                      return (
                                        <div
                                          className="form-check mb-2"
                                          key={batchItem.id}
                                        >
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`batch_${batchItem.id}`}
                                            name="batch_id[]"
                                            value={batchId}
                                            checked={isSelected}
                                            onChange={() =>
                                              handleBatchToggle(batchId)
                                            }
                                          />

                                          <label
                                            htmlFor={`batch_${batchItem.id}`}
                                            className="form-check-label"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {batchItem.title}

                                            {shortCourseTitle && (
                                              <span className="text-muted">
                                                {" "}
                                                ({shortCourseTitle})
                                              </span>
                                            )}
                                          </label>
                                        </div>
                                      );
                                    })
                                  )}
                                </div>

                                {batch?.length > 0 && (
                                  <small className="text-muted">
                                    {selectedBatchIds.length} of {batch.length}{" "}
                                    selected
                                  </small>
                                )}

                                {error?.batch_id && (
                                  <div className="text-danger small mt-1">
                                    {Array.isArray(error.batch_id)
                                      ? error.batch_id[0]
                                      : error.batch_id}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <hr className="my-4" />

                          {/* =================================================
                              MARKS & RESULT
                          ================================================== */}
                          <div className="mb-4">
                            <div className="d-flex align-items-center mb-3">
                              <i className="ri-award-line text-primary fs-5 me-2"></i>

                              <div>
                                <h5 className="mb-0 fw-semibold">
                                  Marks & Result
                                </h5>

                                <small className="text-muted">
                                  Configure how marks will be calculated.
                                </small>
                              </div>
                            </div>

                            <div className="row g-3">
                              {/* Exam Mode */}
                              <div className="col-md-4">
                                <label className="form-label">Exam Mode</label>

                                <select
                                  name="exam_mode"
                                  className="form-select"
                                  value={examMode}
                                  onChange={(e) => setExamMode(e.target.value)}
                                >
                                  <option value="normal">Normal Test</option>

                                  <option value="combined">
                                    Combined Test
                                  </option>
                                </select>
                              </div>

                              {/* Combined Marks */}
                              {examMode === "combined" && (
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Combined Total Marks
                                  </label>

                                  <input
                                    type="number"
                                    name="combined_marks"
                                    className="form-control"
                                    value={combinedMarks}
                                    onChange={(e) =>
                                      setCombinedMarks(e.target.value)
                                    }
                                    placeholder="Enter total marks"
                                  />
                                </div>
                              )}

                              {/* Result Type */}
                              <div className="col-md-4">
                                <label className="form-label">
                                  Result Type
                                </label>

                                <select
                                  name="result_type"
                                  className="form-select"
                                  value={resultType}
                                  onChange={(e) =>
                                    setResultType(e.target.value)
                                  }
                                >
                                  <option value="numerical">Numerical</option>

                                  <option value="grading">Grading</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          {/* =================================================
                              SUBJECTS
                          ================================================== */}
                          {examMode === "normal" && (
                            <>
                              <hr className="my-4" />

                              <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                                  <div className="d-flex align-items-center">
                                    <i className="ri-book-open-line text-primary fs-5 me-2"></i>

                                    <div>
                                      <h5 className="mb-0 fw-semibold">
                                        Subjects
                                      </h5>

                                      <small className="text-muted">
                                        Select subjects and enter their marks.
                                      </small>
                                    </div>
                                  </div>

                                  <span className="badge bg-label-primary">
                                    {selectedSubjectIds.length} Selected
                                  </span>
                                </div>

                                {!selectedCourseId ? (
                                  <div className="text-center border rounded-2 py-5 text-muted">
                                    <i className="ri-book-open-line fs-2 d-block mb-2"></i>

                                    <div>Select a course to view subjects.</div>
                                  </div>
                                ) : selectedSubjects?.length === 0 ? (
                                  <div className="text-center border rounded-2 py-4 text-muted">
                                    No subjects available for this course.
                                  </div>
                                ) : (
                                  <div className="row g-3">
                                    {selectedSubjects?.map((subject) => {
                                      const isSelected =
                                        selectedSubjectIds.includes(
                                          Number(subject.id),
                                        );

                                      return (
                                        <div
                                          className="col-xl-3 col-lg-4 col-md-6"
                                          key={subject.id}
                                        >
                                          <div
                                            className={`border rounded-2 p-3 h-100 ${
                                              isSelected
                                                ? "border-primary bg-label-primary"
                                                : ""
                                            }`}
                                          >
                                            <div className="d-flex align-items-center justify-content-between">
                                              <div className="d-flex align-items-center">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input me-2"
                                                  id={`subject_${subject.id}`}
                                                  name="subjects[]"
                                                  value={subject.id}
                                                  checked={isSelected}
                                                  onChange={() =>
                                                    handleCheckboxChange(
                                                      subject,
                                                    )
                                                  }
                                                />

                                                <label
                                                  htmlFor={`subject_${subject.id}`}
                                                  className="fw-medium mb-0"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  {subject.name}
                                                </label>
                                              </div>

                                              {isSelected &&
                                                Number(marksList[subject.id]) >
                                                  0 && (
                                                  <span className="badge bg-label-success">
                                                    {marksList[subject.id]}
                                                  </span>
                                                )}
                                            </div>

                                            {isSelected && (
                                              <div className="mt-3">
                                                <label className="form-label small">
                                                  Marks
                                                </label>

                                                <input
                                                  type="number"
                                                  className="form-control form-control-sm"
                                                  placeholder="Enter marks"
                                                  value={
                                                    marksList[subject.id] ?? ""
                                                  }
                                                  onChange={(e) =>
                                                    handleMarksChange(
                                                      subject.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {/* =================================================
                              TIMETABLE
                          ================================================== */}
                          <hr className="my-4" />

                          <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                              <div className="d-flex align-items-center">
                                <i className="ri-calendar-line text-primary fs-5 me-2"></i>

                                <div>
                                  <h5 className="mb-0 fw-semibold">
                                    {examMode === "combined"
                                      ? "Exam Timetable"
                                      : "Subject Timetable"}
                                  </h5>

                                  <small className="text-muted">Optional</small>
                                </div>
                              </div>

                              <button
                                type="button"
                                className={`btn btn-sm ${
                                  enableTimeTable
                                    ? "btn-outline-danger"
                                    : "btn-outline-primary"
                                }`}
                                onClick={() =>
                                  setEnableTimeTable(!enableTimeTable)
                                }
                              >
                                <i
                                  className={`${
                                    enableTimeTable
                                      ? "ri-close-line"
                                      : "ri-calendar-line"
                                  } me-1`}
                                ></i>

                                {enableTimeTable
                                  ? "Remove Timetable"
                                  : "Add Timetable"}
                              </button>
                            </div>

                            {enableTimeTable && (
                              <div className="mt-3">
                                {/* Combined Exam */}
                                {examMode === "combined" ? (
                                  <div className="table-responsive border rounded-2">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead>
                                        <tr>
                                          <th>Exam</th>
                                          <th>Date</th>
                                          <th>Start Time</th>
                                          <th>End Time</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr>
                                          <td className="fw-medium">
                                            Combined Exam
                                          </td>

                                          <td>
                                            <input
                                              type="date"
                                              className="form-control"
                                              value={
                                                combinedSchedule.date || ""
                                              }
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "date",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="time"
                                              className="form-control"
                                              value={
                                                combinedSchedule.start_time ||
                                                ""
                                              }
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "start_time",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="time"
                                              className="form-control"
                                              value={
                                                combinedSchedule.end_time || ""
                                              }
                                              onChange={(e) =>
                                                handleCombinedScheduleChange(
                                                  "end_time",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                ) : scheduleData.length === 0 ? (
                                  <div className="border rounded-2 text-center py-4 text-muted">
                                    <i className="ri-calendar-line fs-3 d-block mb-2"></i>
                                    Select subjects to create their timetable.
                                  </div>
                                ) : (
                                  <div className="table-responsive border rounded-2">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead>
                                        <tr>
                                          <th>Subject</th>
                                          <th>Date</th>
                                          <th>Start Time</th>
                                          <th>End Time</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {scheduleData.map((row, index) => (
                                          <tr key={row.subject_id ?? index}>
                                            <td className="fw-medium">
                                              {row.subject_name}
                                            </td>

                                            <td>
                                              <input
                                                type="date"
                                                className="form-control"
                                                value={row.date || ""}
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "date",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>

                                            <td>
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={row.start_time || ""}
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "start_time",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>

                                            <td>
                                              <input
                                                type="time"
                                                className="form-control"
                                                value={row.end_time || ""}
                                                onChange={(e) =>
                                                  handleScheduleChange(
                                                    index,
                                                    "end_time",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* =================================================
                              TOTAL MARKS + UPDATE
                          ================================================== */}
                          <div className="border-top pt-4 mt-4">
                            <div className="row align-items-end">
                              <div className="col-md-4 mb-3 mb-md-0">
                                <label className="form-label">
                                  Total Marks
                                </label>

                                <input
                                  type="number"
                                  name="total_marks"
                                  className="form-control fw-bold"
                                  value={totalMarks}
                                  readOnly
                                />

                                <small className="text-muted">
                                  {examMode === "normal"
                                    ? "Calculated from subject marks."
                                    : "Calculated from combined marks."}
                                </small>
                              </div>

                              <div className="col-md-8">
                                <div className="d-flex justify-content-end gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() => navigate(-1)}
                                    disabled={loading}
                                  >
                                    Cancel
                                  </button>

                                  <button
                                    className="btn btn-primary px-4"
                                    disabled={loading}
                                    type="submit"
                                  >
                                    {loading ? (
                                      <>
                                        <span
                                          className="spinner-border spinner-border-sm me-2"
                                          role="status"
                                        ></span>
                                        Updating...
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-save-line me-1"></i>
                                        Update Test
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateTest;
